import { render, staticRenderFns } from "./ReviewSequence.vue?vue&type=template&id=32c3c593&scoped=true"
import script from "./ReviewSequence.vue?vue&type=script&lang=js"
export * from "./ReviewSequence.vue?vue&type=script&lang=js"
import style0 from "./ReviewSequence.vue?vue&type=style&index=0&id=32c3c593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3c593",
  null
  
)

export default component.exports